
<div *ngIf="showAnnouncement" class="alert alert-warning alert-dismissible fade show" role="alert">
    <span [innerHTML]="announcementText"></span>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>